import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  api,
  callApiSaqsCreate,
  callApiSaqsPatch,
  callApiSaqsDelete,
} from "../../services/index";

import { setStorageItem, removeAllStorage } from "../../helpers/";

import {
  SAQ_CREATE_SUCCESS,
  SAQ_DELETE_SUCCESS,
  WHITE_LABEL_BUSINESS_FETCH_SUCCESS,
  WHITE_LABEL_BUSINESS_FETCH_ERROR,
} from "../types";

export const onClickSaveSaqData = (data) => {
  return async (dispatch) => {
    if (data.saqId) {
      const saqId = data.saqId;
      delete data.saqId;

      return callApiSaqsPatch(saqId, data).then(async (res) => {
        dispatch({
          type: SAQ_CREATE_SUCCESS,
          payload: res,
        });

        if (data.status === "completed") {
          toast.success("SAQ-" + data.type + " completed successfully.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });

          data.history.push("/dashboard");
        }
      });
    } else {
      return callApiSaqsCreate(data).then(async (res) => {
        dispatch({
          type: SAQ_CREATE_SUCCESS,
          payload: res,
        });

        if (data.status === "completed") {
          toast.success("SAQ-" + data.type + " completed successfully.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });

          data.history.push("/dashboard");
        }
      });
    }
  };
};

export const onClickDeleteSaqData = (data) => {
  return async (dispatch) => {
    if (data.saqId) {
      return callApiSaqsDelete(data.saqId).then(async (res) => {
        dispatch({
          type: SAQ_DELETE_SUCCESS,
          payload: res,
        });

        toast.success("SAQ record deleted successfully.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });

        // data.history.push("/dashboard?success=true");
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      });
    }
  };
};

export const onClickGetWhiteLabelBusinesses = (data) => {
  return async (dispatch) => {
    if (data.saqId) {
      return callApiSaqsDelete(data.saqId).then(async (res) => {
        dispatch({
          type: SAQ_DELETE_SUCCESS,
          payload: res,
        });

        toast.success("SAQ record deleted successfully.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });

        // data.history.push("/dashboard?success=true");
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      });
    }
  };
};
